import {Phone, Mail, MapPin, Clock, MessageCircleDashed as MessageCircle} from 'lucide-react'
import ContactForm from '@/components/ContactForm'

export default function ContactPage() {
  return (
    <div>
      <section className="py-14 lg:py-20 bg-navy-50">
        <div className="max-w-5xl mx-auto px-5 lg:px-8 text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white border border-navy-200 text-navy-600 text-xs font-bold uppercase tracking-wider">
            Contact
          </div>
          <h1 className="mt-5 text-4xl lg:text-5xl font-extrabold text-navy-700 tracking-tight leading-[1.05] text-balance">
            Une intervention ? Un devis ? <span className="text-urgent-600">Contactez-nous.</span>
          </h1>
          <p className="mt-5 text-lg text-navy-500 leading-relaxed max-w-2xl mx-auto">
            Pour une urgence, appelez-nous directement. Pour toute autre demande, utilisez le formulaire ou WhatsApp.
          </p>
        </div>
      </section>

      <section className="py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-10 lg:gap-14">
          <div className="space-y-4">
            <a href="tel:+41796430399" className="block bg-white rounded-2xl p-6 border border-navy-100 hover:shadow-elevated transition-shadow">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl gradient-urgent flex items-center justify-center flex-shrink-0">
                  <Phone className="w-6 h-6 text-white" strokeWidth={2.5} />
                </div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-urgent-600">Urgence 24/7</div>
                  <div className="text-2xl font-extrabold text-navy-700">079 643 03 99</div>
                  <div className="text-sm text-navy-500 mt-1">Réponse immédiate, jour et nuit</div>
                </div>
              </div>
            </a>

            <a href="https://wa.me/41796430399" target="_blank" rel="noopener noreferrer" className="block bg-white rounded-2xl p-6 border border-navy-100 hover:shadow-elevated transition-shadow">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl bg-[#25D366] flex items-center justify-center flex-shrink-0">
                  <MessageCircle className="w-6 h-6 text-white" strokeWidth={2.5} />
                </div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-[#25D366]">WhatsApp</div>
                  <div className="text-xl font-extrabold text-navy-700">Écrivez-nous</div>
                  <div className="text-sm text-navy-500 mt-1">Réponse rapide dans la journée</div>
                </div>
              </div>
            </a>

            <a href="mailto:contact@nexaco.ch" className="block bg-white rounded-2xl p-6 border border-navy-100 hover:shadow-elevated transition-shadow">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl gradient-trust flex items-center justify-center flex-shrink-0">
                  <Mail className="w-6 h-6 text-white" strokeWidth={2.5} />
                </div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-navy-500">Email</div>
                  <div className="text-lg font-extrabold text-navy-700 break-all">contact@nexaco.ch</div>
                  <div className="text-sm text-navy-500 mt-1">Devis et demandes générales</div>
                </div>
              </div>
            </a>

            <div className="bg-white rounded-2xl p-6 border border-navy-100">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl bg-navy-50 flex items-center justify-center flex-shrink-0">
                  <Clock className="w-6 h-6 text-navy-700" strokeWidth={2.5} />
                </div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-navy-500">Horaires</div>
                  <div className="text-lg font-extrabold text-navy-700">24h/24 · 7j/7</div>
                  <div className="text-sm text-navy-500 mt-1">Y compris week-ends et jours fériés</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-6 border border-navy-100">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-2xl bg-navy-50 flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-6 h-6 text-navy-700" strokeWidth={2.5} />
                </div>
                <div>
                  <div className="text-xs font-bold uppercase tracking-wider text-navy-500">Zone d'intervention</div>
                  <div className="text-lg font-extrabold text-navy-700">Suisse romande</div>
                  <div className="text-sm text-navy-500 mt-1">Genève · Vaud · Neuchâtel · Fribourg · Valais</div>
                </div>
              </div>
            </div>

            <div className="rounded-2xl overflow-hidden border border-navy-100 shadow-soft">
              <iframe
                title="Carte Suisse romande"
                src="https://www.openstreetmap.org/export/embed.html?bbox=5.957%2C46.156%2C7.215%2C46.789&layer=mapnik"
                className="w-full h-64 border-0"
                loading="lazy"
              />
            </div>
          </div>

          <div>
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  )
}
